import { useSelector } from 'react-redux';

import { getOptionalAccountId } from '../../../../configuration/tokenHandling/tokenSlice';
import { isOnFreeTrialPage } from './isOnFreeTrialPage';

type GoogleAnalyticsEventAction = 'startFreeTrial' | 'freeTrial' | 'checkoutSwitchToGeoL' | 'manEULAHint';

/*
 * Only use this function top-level inside React components, see https://legacy.reactjs.org/docs/hooks-rules.html
 */
export function useTrackingAttributes(action: GoogleAnalyticsEventAction, trigger: 'click' | 'visibility') {
    const accountId = useSelector(getOptionalAccountId);
    return {
        'data-track-ga-event-trigger': trigger,
        'data-track-ga-event-category': 'marketplace',
        'data-track-ga-event-action': `${action}_${trigger}`,
        'data-track-ga-event-label': `accountId::${accountId}`,
    };
}

export function useFreeTrialTrackingAttributes(trigger: 'click' | 'visibility') {
    const trackingAttributes = useTrackingAttributes('freeTrial', trigger);
    if (!isOnFreeTrialPage()) {
        return;
    }
    return trackingAttributes;
}

export function useStartFreeTrialTrackingAttributes(trigger: 'click' | 'visibility') {
    return useTrackingAttributes('startFreeTrial', trigger);
}
